/** Due date (YYYY-MM-DD) plus whether an unconfirmed task is past it. */
export const taskDue = (task: {
  dueAt?: string | null;
  confirmedAt?: string | null;
}) => {
  const date = task.dueAt?.slice(0, 10) ?? "";
  const overdue =
    !task.confirmedAt && !!task.dueAt && new Date(task.dueAt) < new Date();
  return { date, overdue };
};

export type TaskDue = ReturnType<typeof taskDue>;
